'use client';

import { MoviesHeroScrollerTile } from '@/types/movies-hero-scroller';
import { commonFetch, CommonFetchResponse } from '@/utils/common-fetch';
import { buildUrlWithParams } from '@/utils/url-params';

class MoviesHeroScrollerApiService {
  private readonly baseUrl = '/papi/movies/hero-scroller';

  async getTiles(theaterId?: number, timeZone?: string, signal?: AbortSignal): Promise<CommonFetchResponse<MoviesHeroScrollerTile[]>> {
    return await commonFetch<MoviesHeroScrollerTile[]>(
      buildUrlWithParams(this.baseUrl, { theaterId, timeZone }),
      signal ? { signal } : undefined
    );
  }
}

export const moviesHeroScrollerApiService = new MoviesHeroScrollerApiService();
